<template>
    <div class="fixed top-0 right-0 z-100 mt-16 mr-2">
        <div v-if="$root.errors.any()" class="mx-auto mb-4 max-w-2xl rounded-b border-t-4 border-red-500 bg-red-100 px-4 py-3 text-red-900 shadow-md" role="alert">
            <p class="font-bold leading-normal">Please fix the following errors:</p>
            <ul class="list-none p-0 leading-normal">
                <li v-for="(err, field) in $root.errors.all()" :key="`form-errors-${field}`">
                    <p v-for="(error, i) in err" :key="i">{{ error }}</p>
                </li>
            </ul>
        </div>
        <div v-if="shared.errors" class="mx-auto mb-4 max-w-2xl rounded-b border-t-4 border-watermelon-500 bg-watermelon-100 px-4 py-3 text-watermelon-900 shadow-md" role="alert">
            <p class="font-bold leading-normal">Error:</p>
            <p v-for="(error, index) in shared.errors" :key="`session-errors-${index}`" class="leading-normal">{{ error }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ErrorMessages',
        components: {},
        filters: {},
        mixins: [],
        props: {},
        data() {
            return {};
        },
        methods: {},
    };
</script>
